<template lang="pug">
    Select(v-model="select" :multiple="true" :label-in-value="true" @on-change="handleOnChange")
        Option(v-for="option in dynamicOptions" :value="option.label" :key="option.label") {{ option.label }}
</template>
<script>
import enumList from "@/libs/enumList";

export default {
    name: "ProxySetHeader",
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        formData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            select: [],
            initialSelect: [],
        };
    },
    methods: {
        handleOnChange(value) {
            this.$emit(
                "input",
                value.map((v) => v.label)
            );
        },
    },
    computed: {
        dynamicOptions() {
            const systemOptions = enumList.PROXY_SET_HEADER_SYSTEM_OPTIONS.map((item) => ({ label: item, value: item }));

            const { customVariables } = this.formData;
            if (!customVariables || customVariables.length === 0) return systemOptions;

            const customOptions = customVariables.map(({ key, value }) => ({
                label: key,
                value: value,
            }));
            return [...systemOptions, ...customOptions];
        },
    },
    mounted() {
        this.select = [...this.value];
        this.initialSelect = [...this.value];
    },
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/ProxySetHeader.vue